import { AutomationActionType } from 'services/automation/types';

export const useActionOptionsAvailable = ({
  atsJobId,
  atsListId
}: {
  atsJobId: string | null | undefined;
  atsListId: string | null | undefined;
}) => {
  const actionOptionsAvailable = [];

  if (atsListId) {
    actionOptionsAvailable.push(
      AutomationActionType.CREATE_CANDIDATE_NOTE_FROM_CONVERSATION
    );
  } else if (atsJobId) {
    actionOptionsAvailable.push(AutomationActionType.UPDATE_ATS);
  }

  return { actionOptionsAvailable };
};
